export class TypeNumIdentificationNational {

	public siren: string;

	public irep: string;

	public tvaIntra: string;

	public tahiti: string;

	public frwf: string;

	public ridet: string;

	public siret: string;

	constructor() {
		this.siren = '';
		this.irep = '';
		this.tvaIntra = '';
		this.tahiti = '';
		this.frwf = '';
		this.ridet = '';
		this.siret = '';

	}
}
